var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notification-edit-form',{attrs:{"notification-id":_vm.notificationId}})}
var staticRenderFns = []

export { render, staticRenderFns }